import { useHive } from "@/store/useHive";
import { useWorkflow } from "@/store/workflowStore";
import { useExecution } from "@/store/executionStore";

/** Re-pull all org-scoped data after the active organization changes. */
export async function rehydrateOrgData(): Promise<void> {
  await Promise.all([
    useHive.getState().hydrate(),
    useWorkflow.getState().hydrate(),
    useExecution.getState().hydrate(),
  ]);
}
